import React, { useState } from 'react';
import '../App.css';
import authService from '../services/authService';

const SessionExpirationAlert = ({ onExtend, onLogout, remainingSeconds }) => {
  const [isExtending, setIsExtending] = useState(false);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}분 ${secs}초`;
  };

  const handleExtend = async () => {
    if (isExtending) return;
    setIsExtending(true);
    try {
      const result = await onExtend();
      if (!result?.success) {
        onLogout();
      }
    } catch (error) {
      console.error('Token extension error:', error);
      onLogout();
    } finally {
      setIsExtending(false);
    }
  };

  const handleLogout = () => {
    authService.logout();
    onLogout();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        minWidth: '300px',
        maxWidth: '80%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{ 
          fontSize: '16px', 
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap',
          textAlign: 'center',
          color: 'var(--color-text-primary, #333)'
        }}>
          로그인이 곧 만료됩니다. ({formatTime(remainingSeconds)} 남음)
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: '10px', 
          justifyContent: 'center' 
        }}>
          <button 
            type="button"
            onClick={handleLogout}
            className="btn-rtg btn-monotone-1"
            style={{ padding: '8px 20px' }}
          >
            로그아웃하기
          </button>
          <button 
            type="button"
            onClick={handleExtend}
            className="btn-rtg btn-success"
            style={{ padding: '8px 20px' }}
            disabled={isExtending}
          >
            {isExtending ? '연장 중...' : '로그인 연장하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpirationAlert;

